function truncate(str: string) {
  return str.length > 0
    ? str.substr(0, 8) + "..." + str.substr(str.length - 8, str.length - 1)
    : str;
}

export default truncate;
